<style lang="less" scoped>
@primary: #2d8cf0;

.menu-search {
  position: relative;
  width: 240px;
  line-height: normal;
  transition: width 0.2s ease;

  &.focused {
    width: 320px;
  }
}

.ms-box {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 10px 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  cursor: text;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
  }

  .focused & {
    border-color: #fff;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(45, 140, 240, 0.35);
  }
}

.ms-icon {
  flex: none;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.65);

  .focused & {
    color: @primary;
  }
}

.ms-input {
  flex: 1;
  min-width: 0;
  height: 30px;
  margin-left: 8px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #fff;
  font-size: 13px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.55);
  }

  .focused & {
    color: #1c2438;

    &::placeholder {
      color: #bbbec4;
    }
  }
}

.ms-kbd {
  flex: none;
  padding: 0 6px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  line-height: 18px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.ms-clear {
  flex: none;
  padding: 2px;
  color: #bbbec4;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #80848f;
  }
}

.ms-panel {
  position: absolute;
  top: 40px;
  left: 0;
  width: 400px;
  overflow: hidden;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 6px 24px rgba(28, 36, 56, 0.18), 0 0 1px rgba(28, 36, 56, 0.2);
  z-index: 300;
}

.ms-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px 4px;
  color: #9ea7b4;
  font-size: 12px;

  a {
    color: #9ea7b4;

    &:hover {
      color: @primary;
    }
  }
}

.ms-list {
  max-height: 360px;
  margin: 0;
  padding: 4px 6px 6px;
  overflow-y: auto;
  list-style: none;
}

.ms-item {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 10px;
  border-radius: 6px;
  cursor: pointer;

  &.is-current {
    background: #f0f7ff;

    .ms-name {
      color: @primary;
    }

    .ms-enter {
      visibility: visible;
    }
  }
}

.ms-item-icon {
  flex: none;
  width: 16px;
  margin-right: 10px;
  color: #c3cbd6;
  font-size: 14px;
  text-align: center;
}

.ms-name {
  flex: none;
  max-width: 190px;
  overflow: hidden;
  color: #1c2438;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;

  em {
    color: @primary;
    font-style: normal;
    font-weight: 600;
  }
}

.ms-path {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
  overflow: hidden;
  color: #9ea7b4;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
}

.ms-enter {
  flex: none;
  margin-left: 8px;
  color: @primary;
  font-size: 12px;
  visibility: hidden;
}

.ms-empty {
  padding: 28px 0 24px;
  color: #9ea7b4;
  font-size: 13px;
  text-align: center;

  .ivu-icon {
    display: block;
    margin-bottom: 6px;
    color: #dddee1;
    font-size: 28px;
  }
}

.ms-footer {
  padding: 8px 14px;
  border-top: 1px solid #f0f2f5;
  background: #fafbfc;
  color: #9ea7b4;
  font-size: 12px;

  b {
    display: inline-block;
    min-width: 18px;
    margin-right: 4px;
    padding: 0 4px;
    border: 1px solid #e3e8ee;
    border-radius: 3px;
    background: #fff;
    color: #657180;
    font-weight: normal;
    line-height: 16px;
    text-align: center;
  }

  span + span {
    margin-left: 14px;
  }
}
</style>
<template>
  <div class="menu-search" :class="{ focused: focused }">
    <div class="ms-box" @click="focusInput">
      <Icon type="ios-search" class="ms-icon"></Icon>
      <input
        ref="input"
        v-model="keyword"
        class="ms-input"
        :placeholder="focused ? '搜索菜单名称或分组' : '搜索菜单'"
        @focus="onFocus"
        @blur="onBlur"
        @keydown.down.prevent="move(1)"
        @keydown.up.prevent="move(-1)"
        @keydown.enter.prevent="openActive"
        @keydown.esc.prevent="close"
      >
      <Icon v-if="focused && keyword" type="close-circled" class="ms-clear" @mousedown.native.prevent="clearKeyword"></Icon>
      <span v-else-if="!focused" class="ms-kbd">{{ shortcutText }}</span>
    </div>
    <div v-if="focused" class="ms-panel" @mousedown.prevent>
      <template v-if="!keyword.trim()">
        <template v-if="recentItems.length">
          <div class="ms-section">
            <span>最近访问</span>
            <a href="javascript:void(0)" @click="clearRecent">清空</a>
          </div>
          <ul class="ms-list" ref="list">
            <li
              v-for="(item, index) in recentItems"
              :key="item.url"
              class="ms-item"
              :class="{ 'is-current': index === activeIndex }"
              @mouseenter="activeIndex = index"
              @click="go(item)"
            >
              <Icon type="android-time" class="ms-item-icon"></Icon>
              <span class="ms-name">{{ item.name }}</span>
              <span class="ms-path">{{ item.path }}</span>
              <Icon type="arrow-return-left" class="ms-enter"></Icon>
            </li>
          </ul>
        </template>
        <div v-else class="ms-empty">
          <Icon type="ios-search"></Icon>
          {{ items.length ? '输入菜单名称，快速跳转' : '菜单加载中…' }}
        </div>
      </template>
      <template v-else>
        <ul v-if="results.length" class="ms-list" ref="list">
          <li
            v-for="(item, index) in results"
            :key="item.url"
            class="ms-item"
            :class="{ 'is-current': index === activeIndex }"
            @mouseenter="activeIndex = index"
            @click="go(item)"
          >
            <Icon type="ios-arrow-right" class="ms-item-icon"></Icon>
            <span class="ms-name">
              <template v-for="(seg, i) in item.segments"><em v-if="seg.hit" :key="i">{{ seg.text }}</em><template v-else>{{ seg.text }}</template></template>
            </span>
            <span class="ms-path">{{ item.path }}</span>
            <Icon type="arrow-return-left" class="ms-enter"></Icon>
          </li>
        </ul>
        <div v-else class="ms-empty">
          <Icon type="ios-search"></Icon>
          没有找到「{{ keyword.trim() }}」相关的菜单
        </div>
      </template>
      <div class="ms-footer">
        <span><b>↑</b><b>↓</b>选择</span>
        <span><b>Enter</b>打开</span>
        <span><b>Esc</b>关闭</span>
      </div>
    </div>
  </div>
</template>
<script>
const RECENT_KEY = 'menuSearchRecent'
const RECENT_MAX = 6
const RESULT_MAX = 50

function normalize (text) {
  return (text || '').toLowerCase().replace(/\s+/g, '')
}

export default {
  name: 'MenuSearch',
  data () {
    return {
      // 只放 LeftMenu 按权限算完后有权限的菜单
      items: [],
      keyword: '',
      focused: false,
      activeIndex: 0,
      recentUrls: [],
      shortcutText: /Mac|iPhone|iPad/.test(navigator.platform) ? '⌘ K' : 'Ctrl K'
    }
  },
  computed: {
    itemMap () {
      let map = {}
      this.items.forEach(item => {
        map[item.url] = item
      })
      return map
    },
    recentItems () {
      // 权限变化后没权限的菜单不再出现
      return this.recentUrls.map(url => this.itemMap[url]).filter(item => item)
    },
    results () {
      let kw = normalize(this.keyword)
      if (!kw) {
        return []
      }
      let list = []
      this.items.forEach(item => {
        let name = normalize(item.name)
        let path = normalize(item.path)
        let score = -1
        if (name === kw) {
          score = 0
        } else if (name.indexOf(kw) === 0) {
          score = 1
        } else if (name.indexOf(kw) > 0) {
          score = 2
        } else if (path.indexOf(kw) >= 0) {
          score = 3
        }
        if (score >= 0) {
          list.push({ item: item, score: score })
        }
      })
      list.sort((a, b) => a.score - b.score || a.item.name.length - b.item.name.length)
      return list.slice(0, RESULT_MAX).map(row => {
        return Object.assign({}, row.item, { segments: this.highlight(row.item.name, this.keyword.trim()) })
      })
    },
    visibleList () {
      return this.keyword.trim() ? this.results : this.recentItems
    }
  },
  watch: {
    keyword () {
      this.activeIndex = 0
    },
    '$route' (to) {
      this.recordVisit(to.path)
    }
  },
  created () {
    this.recentUrls = this.loadRecent()
    if (this.$root.menuSearchItems) {
      this.setItems(this.$root.menuSearchItems)
    }
    this.$root.$on('menu-search-items', this.setItems)
  },
  mounted () {
    document.addEventListener('keydown', this.onShortcut)
  },
  beforeDestroy () {
    this.$root.$off('menu-search-items', this.setItems)
    document.removeEventListener('keydown', this.onShortcut)
  },
  methods: {
    setItems (items) {
      this.items = items || []
      this.recordVisit(this.$route.path)
    },
    highlight (text, kw) {
      let lower = text.toLowerCase()
      let key = kw.toLowerCase().replace(/\s+/g, '')
      let start = key ? lower.indexOf(key) : -1
      if (start < 0) {
        return [{ text: text, hit: false }]
      }
      let end = start + key.length
      return [
        { text: text.substring(0, start), hit: false },
        { text: text.substring(start, end), hit: true },
        { text: text.substring(end), hit: false }
      ].filter(seg => seg.text)
    },
    onShortcut (e) {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault()
        this.focusInput()
      }
    },
    focusInput () {
      if (this.$refs.input) {
        this.$refs.input.focus()
      }
    },
    onFocus () {
      this.focused = true
      this.activeIndex = 0
    },
    onBlur () {
      this.focused = false
    },
    close () {
      this.keyword = ''
      if (this.$refs.input) {
        this.$refs.input.blur()
      }
    },
    clearKeyword () {
      this.keyword = ''
    },
    move (step) {
      let len = this.visibleList.length
      if (!len) {
        return
      }
      this.activeIndex = (this.activeIndex + step + len) % len
      this.$nextTick(() => {
        let list = this.$refs.list
        let el = list && list.children[this.activeIndex]
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ block: 'nearest' })
        }
      })
    },
    openActive () {
      let item = this.visibleList[this.activeIndex]
      if (item) {
        this.go(item)
      }
    },
    go (item) {
      // 再查一次权限表，没权限的不跳
      if (!this.itemMap[item.url]) {
        return
      }
      this.close()
      if (this.$route.path !== item.url) {
        this.$router.push(item.url)
      }
    },
    recordVisit (path) {
      if (!path || !this.itemMap[path]) {
        return
      }
      let urls = [path].concat(this.recentUrls.filter(url => url !== path)).slice(0, RECENT_MAX)
      this.recentUrls = urls
      this.saveRecent(urls)
    },
    clearRecent () {
      this.recentUrls = []
      this.saveRecent([])
    },
    loadRecent () {
      try {
        let list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]')
        return Array.isArray(list) ? list : []
      } catch (e) {
        return []
      }
    },
    saveRecent (urls) {
      try {
        window.localStorage.setItem(RECENT_KEY, JSON.stringify(urls))
      } catch (e) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// MenuSearch.vue?cecfce22